import AddIcon from "@assets/icons/plus.svg";
import { useI18n } from "@core/i18n/i18n";
import { MainExercise } from "@domain/exercise/exercise";
import styled from "@emotion/styled";
import { DialogContext, ModalId } from "@ui/components/dialog/dialog-provider";
import { useExerciseLibrary } from "@ui/pages/program-builder/hooks/use-exercise-library";
import { ExerciseLibraryFlow } from "@ui/pages/program-builder/mobile/dialog/mobile-exercise-library-dialog";
import { colors } from "@ui/style/colors";
import React, { useContext } from "react";

interface AddExercisesButtonProps {
	onAdd: (exercises: MainExercise[]) => void;
}

export const AddExercisesButton = ({ onAdd }: AddExercisesButtonProps): JSX.Element => {
	const { format } = useI18n();
	const dialogContext = useContext(DialogContext);
	const { refreshLibraryExercises } = useExerciseLibrary();

	return (
		<Container
			onClick={() => {
				refreshLibraryExercises();
				dialogContext?.openModal(ModalId.MobileExerciseLibrary, {
					exerciseLibraryAddingFlow: ExerciseLibraryFlow.Default,
					onClose: exercises => onAdd(exercises as MainExercise[]),
				});
			}}
		>
			<IconContainer>
				<AddIcon width={14} height={14} color={colors.black} />
			</IconContainer>
			<div className="p-size-s-bold">{format("programBuilder.dayTable.addExercisesButton")}</div>
		</Container>
	);
};

const Container = styled.div`
	display: flex;
	gap: 10px;
	padding: 6px;
	margin-left: -6px;
	width: fit-content;
	cursor: pointer;
	place-items: center;
`;

const IconContainer = styled.div`
	width: 32px;
	height: 32px;
	display: grid;
	place-items: center;
	place-content: center;
	border-radius: 16px;
	background-color: ${colors.primary25};
`;
